import { Link } from "react-router-dom";
import { friendLinks, profileInfo } from "@/mocks/site";

export default function SiteIntro() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="mb-2 flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" />
              About This Site
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于本站
            </h2>
            <p className="mt-5 text-sm leading-loose text-foreground-600 md:text-base">
              「佐佐木明希官网」是一个聚焦日本演员佐佐木明希的明星资讯与影视作品门户。我们以清晰的信息层级与编辑式的排版，整理她的最新动态、作品档案与演艺资料，让关注她的观众可以快速、舒适地获取想要的内容。
            </p>
            <p className="mt-4 text-sm leading-loose text-foreground-600 md:text-base">
              站内提供资讯分类浏览、作品多维筛选、关键词搜索与相关推荐等功能，帮助你从任何一条线索出发，追踪她的完整演艺轨迹。
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              了解更多
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
              <div className="flex items-center gap-4">
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full">
                  <img
                    src={profileInfo.avatar}
                    alt="佐佐木明希个人头像 - 明星资料"
                    title="佐佐木明希 个人资料"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-heading text-lg font-bold text-foreground-950">{profileInfo.name}</p>
                  <p className="text-xs text-foreground-500">
                    {profileInfo.roman} · {profileInfo.birthplace}
                  </p>
                </div>
              </div>
              <p className="mt-5 border-l-2 border-accent-400 pl-4 font-heading text-sm leading-relaxed text-foreground-700">
                「{profileInfo.quote}」
              </p>
              <div className="mt-6">
                <p className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-500">
                  友情链接
                </p>
                <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                  {friendLinks.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.url}
                        className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                      >
                        <i className="ri-link text-foreground-400" aria-hidden="true" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}